export class EmptyBodyError extends Error {}
